module.exports = __webpack_public_path__ + "img/heart_half.ac393284.svg";